export interface SecuredMenuModel {
  children: SecuredMenuModel[];
  contextualHelpId: number | null;
  id: number;
  isActive: boolean;
  isLeaf: boolean;
  isVisibleInThisDatabase: boolean;
  levelId: number;
  name: string;
  parentMenuId: number;
  sequenceNumber: number;
  sysApplicationId: number;
  sysDataExplorerGridId: number | null;
  sysIntegrationTypeIdRequiredToBeVisible: unknown;
  isAtFranchiseLevel: boolean;
  // custom
  icon?: string;
  isOpen?: boolean;
  data?: string;
  searchParameter?: string;
  report_Path?: string;
}

/** Leaf menus under Case Integrations, used both to route and to gate the route. */
export enum caseIntegrationMenuItems {
  Cnesst = 7260,
  Saaq = 7273,
}

export enum menuItems {
  None = 0,

  AppFunderBilling = 5000,
  AppConfiguration = 5001,
  AppReportsKPIs = 5002,
  CentralBooking = 5003,
  Marketing = 5004,
  // Not used
  // CentralManagement = 5005,
  CaseIntegrations = 5005,
  PaymentProcessing = 5006,
  AppManage = 5007,
}
